import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.scss";
import App from './App';
import Errorsxx from "./components/Errorsxx";

//Bootstrap Style
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Provider } from 'react-redux';
import { store, persistor } from './libs/redux/store/store';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
        <Errorsxx />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
